




import { Component, Vue } from "vue-property-decorator";
import * as firebase from "firebase/app";
import "firebase/auth";

@Component({
  components: {}
})
export default class Login extends Vue {
  constructor(props: any) {
    super(props);
    this.signOut();
  }

  async signOut() {
    await firebase.auth().signOut();
    this.$router.push({ name: "home" });
  }
}
